import React, { useState, useEffect, useRef, useCallback } from 'react';
import { 
  listarCategorias, 
  listarCategoriasVinos,
  listarCategoriasConProductosIniciales
} from '../../../repositorios/apiServer';

export const useCategorias = () => {
  const [categorias, setCategorias] = useState([]);
  const [categoriaID, setCategoriaID] = useState(null);
  const [mostrarVinos, setMostrarVinos] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [categoriasSinProductos, setCategoriasSinProductos] = useState(new Set());
  const [preloadedProducts, setPreloadedProducts] = useState({});
  const sectionRefs = useRef({});

  const getID = (objeto) => {
    return objeto._id || objeto.id;
  };

  const registrarCategoriaSinProductos = useCallback((categoriaId) => {
    setCategoriasSinProductos(prev => new Set(prev).add(categoriaId));
  }, []);

  useEffect(() => {
    setCategoriasSinProductos(new Set());
  }, [mostrarVinos]);

  useEffect(() => {
    async function fetchCategorias() {
      setCargando(true);
      try {
        const categoriasResponse = await listarCategoriasConProductosIniciales();
        
        if (categoriasResponse && categoriasResponse.categorias) {
          setCategorias(categoriasResponse.categorias);
          
          if (categoriasResponse.productosIniciales) {
            setPreloadedProducts(categoriasResponse.productosIniciales);
          }
          
          const refs = {};
          categoriasResponse.categorias.forEach(cat => {
            refs[cat._id || cat.id] = React.createRef();
          });
          sectionRefs.current = refs;
          
          const primerCategoriaId = categoriasResponse.categorias[0]._id || categoriasResponse.categorias[0].id;
          setCategoriaID(primerCategoriaId);
        } else {
          const categoriasSimples = await listarCategorias();
          if (categoriasSimples && Array.isArray(categoriasSimples)) {
            setCategorias(categoriasSimples);
            
            const refs = {};
            categoriasSimples.forEach(cat => {
              refs[cat._id || cat.id] = React.createRef();
            });
            sectionRefs.current = refs;
            
            if (categoriasSimples.length > 0) {
              const primerCategoriaId = categoriasSimples[0]._id || categoriasSimples[0].id;
              setCategoriaID(primerCategoriaId);
            }
          }
        }
      } catch (error) {
        console.error("Error al cargar categorías:", error);
      } finally {
        setCargando(false);
      }
    }
    
    fetchCategorias();
  }, []);

  const toggleVinos = async () => {
    setCargando(true);
    try {
      if (mostrarVinos) {
        const categoriasNormales = await listarCategorias();
        
        if (categoriasNormales && Array.isArray(categoriasNormales)) {
          setCategorias(categoriasNormales);
          
          const refs = {};
          categoriasNormales.forEach(cat => {
            refs[cat._id || cat.id] = React.createRef();
          });
          sectionRefs.current = refs;
          
          if (categoriasNormales.length > 0) {
            const primerCategoriaId = categoriasNormales[0]._id || categoriasNormales[0].id;
            setCategoriaID(primerCategoriaId);
          } else {
            setCategoriaID(null);
          }
        }
      } else {
        const categoriasVinos = await listarCategoriasVinos();
        
        if (categoriasVinos && Array.isArray(categoriasVinos) && categoriasVinos.length > 0) {
          setCategorias(categoriasVinos);

          const refs = {};
          categoriasVinos.forEach(cat => {
            refs[cat._id || cat.id] = React.createRef();
          });
          sectionRefs.current = refs;
          
          const primerCategoriaId = categoriasVinos[0]._id || categoriasVinos[0].id;
          setCategoriaID(primerCategoriaId);
        } else {
          alert("No se pudieron cargar las categorías de vinos. Por favor, verifica que existan en la base de datos.");
          return;
        }
      }
      
      setMostrarVinos(!mostrarVinos);
      setPreloadedProducts({});
    } catch (error) {
      alert("Ha ocurrido un error al cargar las categorías. Inténtalo de nuevo.");
    } finally {
      setCargando(false);
    }
  };

  return {
    categorias,
    categoriaID,
    setCategoriaID,
    mostrarVinos,
    cargando,
    categoriasSinProductos,
    preloadedProducts,
    sectionRefs,
    getID,
    registrarCategoriaSinProductos,
    toggleVinos
  };
};